import SettingsListItem from "../../../@core/types/settings-list-item";

const invoiceSettingsLinks: SettingsListItem[] = [
  {
    label: "MENU.ROW_TYPE",
    capability: "show_invoice_row_type_list",
    url: "/dashboard/invoice/row-type",
    section: "invoice",
  },
  {
    label: "MENU.DOCUMENTS_TYPES",
    capability: "show_invoice_document_type_list",
    url: "/dashboard/invoice/documents-types",
    section: "invoice",
  },
  {
    label: "MENU.DOCUMENTS_CODES",
    capability: "show_invoice_document_code_list",
    url: "/dashboard/invoice/documents-codes",
    section: "invoice",
  },
  {
    label: "MENU.PAYMENTS_TYPES",
    capability: "show_invoice_payment_type_list",
    url: "/dashboard/invoice/payments-types",
    section: "invoice",
  },
  {
    label: "MENU.SERVICE_INVOICE",
    capability: "show_invoice_service_list",
    url: "/dashboard/invoice-services",
    section: "invoice",
  },
  {
    label: "PAYMENTS_MEASURE_UNIT",
    capability: "show_menu_payment_measure_unit_list",
    url: "/dashboard/payment-measure-unit",
    section: "invoice",
  },
  {
    label: "BILLING_FREQUENCIES",
    capability: "show_menu_billing_frequency_list",
    url: "/dashboard/billing-frequency",
    section: "invoice",
  },
  {
    label: "MENU.PAYMENT_TERMS",
    capability: "show_menu_payment_terms_list",
    url: "/dashboard/payment-terms",
    section: "invoice",
  },
];
export default invoiceSettingsLinks;